// src/api/services/phases.service.ts

import { apiClient } from "@/api/client";
import { API_ENDPOINTS } from "@/api/endpoints";
import type {
  PhaseStats,
  PhaseInfo,
  BracketPhase,
  AdvancePhaseRequest,
  Nation,
} from "@/types/api.types";

export const phasesService = {
  // Get current phase stats
  getCurrentPhaseStats: async (): Promise<PhaseStats> => {
    return await apiClient.get(API_ENDPOINTS.PHASES.CURRENT);
  },

  // Get all phases
  getAllPhases: async (): Promise<PhaseInfo[]> => {
    return await apiClient.get(API_ENDPOINTS.PHASES.ALL);
  },

  // Get bracket structure
  getBracket: async (): Promise<BracketPhase[]> => {
    return await apiClient.get(API_ENDPOINTS.PHASES.BRACKET);
  },

  // Get eliminated nations grouped by phase
  getEliminatedNations: async (): Promise<Record<string, Nation[]>> => {
    return await apiClient.get(API_ENDPOINTS.PHASES.ELIMINATED);
  },

  // Get active nations
  getActiveNations: async (): Promise<Nation[]> => {
    return await apiClient.get(API_ENDPOINTS.PHASES.ACTIVE);
  },

  // Advance phase
  advancePhase: async (
    data: AdvancePhaseRequest,
  ): Promise<{ message: string; oldPhase: string; newPhase: string }> => {
    return await apiClient.post(API_ENDPOINTS.PHASES.ADVANCE, data);
  },

  // Simulate auto-advance (testing)
  simulateAutoAdvance: async (): Promise<{ message: string }> => {
    return await apiClient.post(API_ENDPOINTS.PHASES.SIMULATE_ADVANCE);
  },
};
